module.exports = __webpack_public_path__ + "img/yyxfc.f5502721.png";